import { Navigate, useLocation } from 'react-router-dom';
import { useWebpages } from '@/contexts/WebpagesContext';
import { RouteLoader } from '@/components/RouteLoader';
import { rememberPendingDestination } from '@/lib/auth-next';

/**
 * Requires auth but does NOT gate on onboarding completion — that would
 * cause an infinite redirect for the onboarding pages themselves.
 *
 * Each onboarding page handles its own "already complete" redirect
 * logic (e.g. completed_at set → bounce to /saved).
 */
export function OnboardingRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthLoading } = useWebpages();
  const location = useLocation();

  if (isAuthLoading) {
    return <RouteLoader />;
  }

  if (!user) {
    const redirectTarget = `${location.pathname}${location.search}${location.hash}`;
    rememberPendingDestination(redirectTarget);
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
